import React from 'react';
import './LongTermScheduleCalendar.scss';
import {
    Button,
    FormGroup,
    Input,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNoteSticky } from '@fortawesome/free-regular-svg-icons';
import {
    faCancel,
    faCommentSlash,
    faSave,
} from '@fortawesome/free-solid-svg-icons';
import { FormLabel, toasty } from '../common/forms/FormElements';
import { util } from '../Util';
import { ApiRoutes } from '../ApiRoutes';
import moment from 'moment';

export default class JobNoteButton extends React.Component {
    constructor(props) {
        super(props);

        const { job } = props;

        this.state = {
            updatedJobNotes: job?.notes ?? '',
            showModal: false,
            anyChanges: false,
            saving: false,
        };
    }

    toggleModal = () => {
        const { showModal } = this.state;

        if (!showModal) {
            const { job } = this.props;

            this.setState({
                updatedJobNotes: job?.notes ?? '',
                showModal: true,
                anyChanges: false,
            });
        } else {
            this.setState({ showModal: false });
        }
    };

    onNotesChange = (e) => {
        const updatedJobNotes = e.target.value ?? '';
        this.setState({ updatedJobNotes, anyChanges: true });
    };

    onSave = async () => {
        const { saving } = this.state;

        if (saving) {
            return;
        }

        this.setState({ saving: true });

        const { job, onJobNotesUpdated } = this.props;
        const { updatedJobNotes } = this.state;

        try {
            const jobResponse = await util.fetch.andGetResponse(
                util.fetch.types.post,
                ApiRoutes.job.updateNotes(job.id),
                updatedJobNotes
            );

            if (jobResponse) {
                onJobNotesUpdated(updatedJobNotes);

                toasty.success('Order Notes Updated');

                this.toggleModal();
            }
        } catch (e) {
            console.error({ e });
        }

        this.setState({ saving: false });
    };

    renderNotesOrNotSpecified = () => {
        const { job } = this.props;

        if (job.notes) {
            return <pre>{job.notes}</pre>;
        }

        return (
            <div className="d-flex">
                <div>
                    <FontAwesomeIcon icon={faCommentSlash} className="mr-1" />
                </div>
                <div>None specified</div>
            </div>
        );
    };

    getIsLtsInThePast = () => {
        const { longTermSchedule } = this.props;

        return moment(longTermSchedule.endDate).isBefore(new Date(), 'day');
    };

    render() {
        const { job } = this.props;

        if (!job) {
            return null;
        }

        const { showModal, updatedJobNotes, anyChanges, saving } = this.state;

        const isLtsInThePast = this.getIsLtsInThePast();

        return (
            <>
                <Button
                    type="button"
                    color="info"
                    outline
                    className="mb-2 w-100"
                    onClick={this.toggleModal}
                    disabled={isLtsInThePast}
                >
                    <div className="d-flex">
                        <div className="mr-4 text-left w-33 btn-title">
                            <FontAwesomeIcon
                                icon={faNoteSticky}
                                className="mr-1"
                            />
                            Order Notes
                        </div>
                        <div className="wrap-container w-100 text-left w-25">
                            {this.renderNotesOrNotSpecified()}
                        </div>
                    </div>
                </Button>

                <Modal size="xl" isOpen={showModal} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>
                        Updating Order Notes
                    </ModalHeader>
                    <ModalBody>
                        <FormGroup className="updated-job-notes">
                            <FormLabel text="Updated Order Notes" />

                            <Input
                                type="textarea"
                                value={updatedJobNotes}
                                onChange={this.onNotesChange}
                                placeholder="None Specified"
                                max={1000}
                                maxLength={1000}
                                rows={6}
                            />

                            <div>
                                {1000 - updatedJobNotes.length} characters
                                remaining
                            </div>
                        </FormGroup>

                        <hr />
                        <div>As a reminder, the original order notes were:</div>

                        {this.renderNotesOrNotSpecified()}
                    </ModalBody>
                    <ModalFooter>
                        <Row className="w-100">
                            <div className="col-6">
                                <Button
                                    type="button"
                                    color="warning"
                                    onClick={this.toggleModal}
                                    className="float-left"
                                >
                                    <FontAwesomeIcon
                                        icon={faCancel}
                                        className="mr-2"
                                    />
                                    Cancel
                                </Button>
                            </div>
                            <div className="col-6">
                                <Button
                                    type="button"
                                    color="success"
                                    className="float-right"
                                    disabled={!anyChanges || saving}
                                    outline={!anyChanges}
                                    onClick={this.onSave}
                                >
                                    <FontAwesomeIcon
                                        icon={faSave}
                                        className="mr-2"
                                        pulse={saving}
                                    />
                                    Update Order Notes
                                </Button>
                            </div>
                        </Row>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}
